export default "__VITE_ASSET__DFd0PUz5__"